/**
 * Semester Defaults and Constants
 * Define standard semester configurations for diploma programs
 */

export const SEMESTERS = [
    { id: '1', name: 'Semester 1', value: 'sem1' },
    { id: '2', name: 'Semester 2', value: 'sem2' },
    { id: '3', name: 'Semester 3', value: 'sem3' },
    { id: '4', name: 'Semester 4', value: 'sem4' },
    { id: '5', name: 'Semester 5', value: 'sem5' },
    { id: '6', name: 'Semester 6', value: 'sem6' },
];

export const COLLEGE_SEMESTERS = SEMESTERS;

export const SEMESTER_LABELS = {
    '1': 'Semester 1',
    '2': 'Semester 2',
    '3': 'Semester 3',
    '4': 'Semester 4',
    '5': 'Semester 5',
    '6': 'Semester 6',
};

export const EXAM_TYPES = [
    { id: 'sessional_1', name: 'Sessional 1' },
    { id: 'sessional_2', name: 'Sessional 2' },
    { id: 'midterm', name: 'Mid-term' },
    { id: 'final', name: 'Final Exam' },
];

export const GRADE_THRESHOLDS = [
    { min: 90, max: 100, grade: 'A+', points: 4.0 },
    { min: 80, max: 89, grade: 'A', points: 3.7 },
    { min: 70, max: 79, grade: 'B+', points: 3.3 },
    { min: 60, max: 69, grade: 'B', points: 3.0 },
    { min: 50, max: 59, grade: 'C', points: 2.0 },
    { min: 40, max: 49, grade: 'D', points: 1.0 },
    { min: 0, max: 39, grade: 'F', points: 0.0 },
];

/**
 * Get grade based on percentage
 */
export const getGrade = (percentage) => {
    const threshold = GRADE_THRESHOLDS.find(t => percentage >= t.min && percentage <= t.max);
    return threshold ? threshold.grade : 'F';
};

/**
 * Get grade points (GPA)
 */
export const getGradePoints = (percentage) => {
    const threshold = GRADE_THRESHOLDS.find(t => percentage >= t.min && percentage <= t.max);
    return threshold ? threshold.points : 0.0;
};
